var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "#4EBBB8",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92548 9.87705L6.6912 7.73248H6.02005V9.87705H5.14062V4.51562H6.99205C7.40348 4.51562 7.75063 4.58762 8.03348 4.73162C8.32148 4.87562 8.53491 5.06848 8.67377 5.3102C8.81777 5.55191 8.88977 5.82191 8.88977 6.1202C8.88977 6.46991 8.78691 6.78877 8.5812 7.07677C8.38063 7.35963 8.06948 7.55248 7.64777 7.65534L8.97463 9.87705H7.92548ZM6.02005 7.03048H6.99205C7.3212 7.03048 7.56805 6.9482 7.73263 6.78363C7.90234 6.61905 7.9872 6.39791 7.9872 6.1202C7.9872 5.84248 7.90491 5.62648 7.74034 5.4722C7.57577 5.31277 7.32634 5.23305 6.99205 5.23305H6.02005V7.03048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyRent);
export default __webpack_public_path__ + "static/media/Property-Rent.c914bfea6e2179949009f93d616f4030.svg";
export { ForwardRef as ReactComponent };